import { gql } from '@apollo/client';

export const UserFragment = gql`
  fragment User on User {
    id
    fullName
    email
    phone
    firebaseUserId
    userAttributes {
      viewedWelcomeMessageTaxYear
      isSsoOnboarding
    }
    companyScopes {
      id
      companyId
      scope
    }
    allowRealCompanyDatetime
    pendingOrFailedStatusOrganizationInvitations {
      id
      derivedState
    }
    companies {
      # Only request minimum fields required. Do not use Company fragment.
      id
    }
    organization {
      ...Organization
    }
    organizationScope
    thomsonReutersConsumerKey
  }
`;
